import { CommercialNetworkDetailsDTO, Option } from 'interfaces';

export const parseCommercialNetworkDetailsDTOIntoOption: (
   commercialNetworkDetailsDTO: CommercialNetworkDetailsDTO,
) => Option = commercialNetworkDetailsDTO => {
   const { id, name } = commercialNetworkDetailsDTO;

   return { label: name, value: id };
};
